import { render } from "./KinshipCalculator.vue?vue&type=template&id=4b0f51bc&scoped=true"
import script from "./KinshipCalculator.vue?vue&type=script&lang=js"
export * from "./KinshipCalculator.vue?vue&type=script&lang=js"

import "./KinshipCalculator.vue?vue&type=style&index=0&id=4b0f51bc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b0f51bc"]])

export default __exports__